/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import {
  FETCHING_HELPDESK_PHONENO,
  FETCHED_HELPDESK_PHONENO,
  FETCH_DEFAULT_HELPDESK_PHONENO
} from '../actions/actionTypes';

const helpdeskState = {
  allPhoneNumbers: null,
  isFetching: false,
  error: null
};

const helpdeskReducer = (state = helpdeskState, action) => {
  switch (action.type) {
    case FETCHING_HELPDESK_PHONENO:
      return Object.assign({}, state, { isFetching: true });
    case FETCHED_HELPDESK_PHONENO:
      return Object.assign({}, state, { isFetching: false, allPhoneNumbers: action.payload, error: null });
    case FETCH_DEFAULT_HELPDESK_PHONENO:
      return Object.assign({}, state, { isFetching: false, allPhoneNumbers: action.payload.helpdeskPhoneNumbers });
    default:
      return state;
  }
};

export default helpdeskReducer;
